import React, {useCallback} from 'react';
import {Icon, genericMessageHandler} from 'shared/helpers';
import {useJobContext, useNotificationContext} from 'contexts';
import {Button} from 'react-bootstrap';
import {PartialJob} from 'shared/types/PartialJob';
import {
    invalidateJob,
    invalidateJobCost,
    useJobResetMutation,
} from 'components/customer/Job/store/jobApi';
import {JobStatusEnum} from 'shared/JobStatus';
import {useAppDispatch} from 'store/customer';

interface VariationResetButtonProps {
    resetJob: () => void;
}

export const useVariationResetButton = (): VariationResetButtonProps => {
    const dispatch = useAppDispatch();
    const {job} = useJobContext() as PartialJob;
    const [jobReset] = useJobResetMutation();
    const {notify} = useNotificationContext();

    const resetJob = useCallback(() => {
        jobReset({jobId: job?.id})
            .unwrap()
            .then(() => {
                dispatch(invalidateJob());
                dispatch(invalidateJobCost());
                genericMessageHandler(
                    notify,
                    {
                        message: 'Job has been unsubmitted',
                    },
                    'success'
                );
            })
            .catch((error) => {
                throw error;
            });
    }, [job]);

    return {
        resetJob,
    };
};

export const VariationResetButton = () => {
    const {job} = useJobContext() as PartialJob;
    const {resetJob} = useVariationResetButton();

    return job?.accepted && job.status < JobStatusEnum.PENDING_PAYMENT ? (
        <Button variant="link" onClick={resetJob} className="nav-link">
            <Icon iconName="Button-Edit.svg" />
            <span>Edit Job</span>
        </Button>
    ) : null;
};
